import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-indv-events',
  templateUrl: './indv-events.component.html',
  styleUrls: ['./indv-events.component.scss']
})
export class IndvEventSolutionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
